import withIcon from './NewIcon';
// @ts-ignore
import IconPayment from './icon/m/payment.svg';

export default withIcon(IconPayment);
